export enum QuoteDetailsEntryStatus {
  IN_CLARIFICATION = "IV01",
  MVCR_IN_CLARIFICATION = "MVCR",
  REJECTED = "EV01",
  ACCEPTED = "EV02",
  RELEASED = "OV10",
  ACTIVE = "Q1",
  EXPIRED = "Q2",
  OPEN = "H2",
  ALL = "ALL",
}

export function getItemStatus(status: string): QuoteDetailsEntryStatus {
  switch (status) {
    case "EV01":
      return QuoteDetailsEntryStatus.REJECTED;
    case "EV02":
      return QuoteDetailsEntryStatus.ACCEPTED;
    case "MVCR":
      return QuoteDetailsEntryStatus.MVCR_IN_CLARIFICATION;
    case "IV01":
      return QuoteDetailsEntryStatus.IN_CLARIFICATION;
    case "OV10":
    case "OV20":
      return QuoteDetailsEntryStatus.RELEASED;
    case "Q1":
      return QuoteDetailsEntryStatus.ACTIVE;
    case "Q2":
      return QuoteDetailsEntryStatus.EXPIRED;
    case "H2":
      return QuoteDetailsEntryStatus.OPEN;
    case "ALL":
    default:
      return QuoteDetailsEntryStatus.ALL;
  }
}
